import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../common/components/UserContext';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import Divider from '@mui/material/Divider';
import globalStyles, { StyledTooltip } from '../common/globalStyles';

export const UserSection = ({ open }) => {
    const navigate = useNavigate();
    const { user, logout } = useUser();

    const handleLogout = async (e) => {
        e.preventDefault();
        await logout();
        navigate('/login');
    };

    return (
        <React.Fragment>
            {open && (
                <>
                    <Divider sx={{ backgroundColor: '#444', my: 1 }} />
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '12px 8px',
                        mb: 1
                    }}>
                        <Avatar
                            sx={{
                                width: 48,
                                height: 48,
                                marginBottom: 1,
                                bgcolor: '#9e2828'
                            }}>
                            {user?.firstName ? user.firstName.charAt(0) : <PersonIcon />}
                        </Avatar>
                        <Typography
                            sx={{
                                color: '#ccc',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                textAlign: 'center'
                            }}>
                            {user ? `${user.firstName} ${user.lastName}` : 'User'}
                        </Typography>
                        <Typography
                            sx={{
                                color: '#777',
                                fontSize: '12px',
                                mb: 1
                            }}>
                            {user ? user.email : 'Loading...'}
                        </Typography>
                    </Box>
                </>
            )}

            <ListItemButton
                component={Link}
                to="/profile"
                sx={{
                    ...globalStyles.mainMenu,
                    width: '100%', // Ensure full width
                    justifyContent: 'flex-start', // Align content to left
                    boxSizing: 'border-box', // Include padding in width calculation
                    paddingRight: 2, // Add some right padding
                    paddingLeft: 2  // Add some left padding
                }}
            >
                <StyledTooltip title="My Profile" placement="right" arrow>
                    <ListItemIcon>
                        <AccountCircleOutlinedIcon sx={{ color: '#f0f0f0', fontSize: '1.3rem' }} />
                    </ListItemIcon>
                </StyledTooltip>
                <ListItemText
                    primary="My Profile"
                    primaryTypographyProps={{ fontSize: '14px', fontWeight: 'normal' }}
                    sx={{ flex: 1 }} // This helps with width
                />
            </ListItemButton>

            <ListItemButton
                onClick={handleLogout}
                sx={{
                    ...globalStyles.mainMenu,
                    width: '100%', // Ensure full width
                    justifyContent: 'flex-start', // Align content to left
                    boxSizing: 'border-box', // Include padding in width calculation
                    paddingRight: 2, // Add some right padding
                    paddingLeft: 2  // Add some left padding
                }}
            >
                <StyledTooltip title="Logout" placement="right" arrow>
                    <ListItemIcon>
                        <LogoutOutlinedIcon sx={{ color: '#f0f0f0', fontSize: '1.3rem' }} />
                    </ListItemIcon>
                </StyledTooltip>
                <ListItemText
                    primary="Logout"
                    primaryTypographyProps={{ fontSize: '14px', fontWeight: 'normal' }}
                    sx={{ flex: 1 }} // This helps with width
                />
            </ListItemButton>
        </React.Fragment>
    );
};